/** Payment status display helpers */
export const PAYMENT_STATUS_CLASS = {
  paid: 'paid',
  refunded: 'refunded',
  partially_paid: 'partially-paid',
  partially_refunded: 'partially-refunded',
  pending: 'pending',
  authorized: 'authorized',
  voided: 'voided',
};

export function formatPaymentStatus(order) {
  if (order?.payment_status_label) return order.payment_status_label;
  const code = String(order?.payment_status || '').trim().toLowerCase();
  const labels = {
    paid: 'Paid',
    refunded: 'Refund',
    partially_paid: 'Partially Paid',
    partially_refunded: 'Partially Refunded',
    pending: 'Pending',
    authorized: 'Authorized',
    voided: 'Voided',
  };
  return labels[code] || (code ? code.replace(/_/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase()) : 'Unknown');
}

export function paymentStatusClass(order) {
  const code = String(order?.payment_status || '').trim().toLowerCase();
  return PAYMENT_STATUS_CLASS[code] || 'unknown';
}
